import Vue from 'vue'
import Vuex from 'vuex'
import album from '@/store/detailAlbum.store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    album,
  }
})
